import React from 'react';
import {
  Dialog, DialogTitle, DialogContent,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TagList from './TagList';
import { APIData } from '../../constants/APIAdresses';
import { ALERT_SEVERITY } from '../../components/AlertDisplay2';

export default function FilePreviewDialog({
  open,
  onClose,
  fileItem,
  tagEditingItemIndex,
  onDeleteTag,
  onAddTag,
  onAddFail
}) {
  if (!fileItem) return null;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        {fileItem.filename}
        <IconButton onClick={onClose} style={{ float: 'right' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          <img
            src={`${APIData.MEDIA}${fileItem.path}`}
            alt={fileItem.filename}
            style={{
              maxWidth: '100%',
              height: 'auto',
              alignSelf: 'center',
              flex: '0 0 auto'
            }}
          />

          <TagList
            fileItem={fileItem}
            title="Tags:"
            onDeleteTag={(tag, idx) => {
              onDeleteTag(tagEditingItemIndex, tag, idx, true);
            }}
            onAddFail={() => {
              onAddFail?.(
                "Beim Hinzufügen von Tag ist ein Fehler aufgetreten (vermutlich doppelter Tag).",
                ALERT_SEVERITY.ERROR
              );
            }}
            onAddTag={(tag) => {
              const newTags = [...fileItem.tags, tag];
              const updatedFileItem = { ...fileItem, tags: newTags };
              onAddTag(updatedFileItem, tagEditingItemIndex);
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
